import React, { useState } from "react";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import "./Contact.css";

function Contact() {
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        phone: "",
        message: "",
    });

    const [status, setStatus] = useState({
        submitting: false,
        success: false,
        error: null,
    });

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setStatus({ submitting: true, success: false, error: null });

        try {
            // Replace with your Formspree endpoint
            const response = await fetch("https://formspree.io/f/xjgebvdo", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(formData),
            });

            if (response.ok) {
                setStatus({ submitting: false, success: true, error: null });
                setFormData({ name: "", email: "", phone: "", message: "" });
            } else {
                const data = await response.json();
                throw new Error(data.error || "Something went wrong. Please try again.");
            }
        } catch (err) {
            setStatus({ submitting: false, success: false, error: err.message });
        }
    };

    return (
        <section className="contact-section" id="contact">
            <Container>
                <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
                    <h1 className="contact-heading">
                        Appreciate You <strong className="gradient-text">Stopping By!</strong>
                    </h1>
                    <p className="contact-subtitle">
                        Thanks for reaching out — I look forward to connecting and exploring what we can build together.
                    </p>
                </Row>

                <Row style={{ justifyContent: "center", paddingBottom: "30px" }}>
                    <Col md={8} lg={6}>
                        <Form onSubmit={handleSubmit} className="contact-form">
                            <Form.Group className="mb-4" controlId="formName">
                                <Form.Control
                                    type="text"
                                    placeholder="Your Name"
                                    name="name"
                                    value={formData.name}
                                    onChange={handleChange}
                                    required
                                    className="contact-input"
                                />
                            </Form.Group>

                            <Form.Group className="mb-4" controlId="formEmail">
                                <Form.Control
                                    type="email"
                                    placeholder="Your Email"
                                    name="email"
                                    value={formData.email}
                                    onChange={handleChange}
                                    required
                                    className="contact-input"
                                />
                            </Form.Group>

                            <Form.Group className="mb-4" controlId="formPhone">
                                <Form.Control
                                    type="tel"
                                    placeholder="Your Phone"
                                    name="phone"
                                    value={formData.phone}
                                    onChange={handleChange}
                                    className="contact-input"
                                />
                            </Form.Group>

                            <Form.Group className="mb-4" controlId="formMessage">
                                <Form.Control
                                    as="textarea"
                                    rows={4}
                                    placeholder="Share your idea or message here..."
                                    name="message"
                                    value={formData.message}
                                    onChange={handleChange}
                                    required
                                    className="contact-input"
                                />
                            </Form.Group>

                            <div className="text-center">
                                <Button
                                    className="contact-btn"
                                    variant="primary"
                                    type="submit"
                                    disabled={status.submitting}
                                >
                                    {status.submitting ? "Sending..." : "Send"}
                                </Button>
                            </div>

                            {status.success && (
                                <div className="alert alert-success mt-4 text-center">
                                    Message sent successfully! I'll get back to you soon.
                                </div>
                            )}

                            {status.error && (
                                <div className="alert alert-danger mt-4 text-center">
                                    {status.error}
                                </div>
                            )}
                        </Form>
                    </Col>
                </Row>
            </Container>
        </section>
    );
}

export default Contact;
